module.exports = __webpack_public_path__ + "static/img/eco-protection-02.620d2d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/eco-protection/eco-protection-02.jpg
// module id = P8X3
// module chunks = 98